"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _chunk2 = _interopRequireDefault(require("lodash/chunk"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right2"));
var _arrowLeft = _interopRequireDefault(require("cccisd-icons/arrow-left2"));
var _pagebreak = _interopRequireDefault(require("cccisd-icons/pagebreak"));
var _pageBreak = _interopRequireDefault(require("cccisd-icons/page-break2"));
var _tabs = _interopRequireDefault(require("./tabs.css"));
var _queryVariablesHelper = _interopRequireDefault(require("../../helpers/queryVariablesHelper.js"));
var _cccisdTabs = _interopRequireDefault(require("cccisd-tabs"));
var _flat = _interopRequireDefault(require("flat"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var match = {};

/**
 * Appdefs ReportWrapper component
 * This component takes a json form definition and transforms it
 * into the impact form page with modal popup  included.
 */
var ReportWrapper = /*#__PURE__*/function (_Component) {
  function ReportWrapper(props) {
    var _this;
    _classCallCheck(this, ReportWrapper);
    _this = _callSuper(this, ReportWrapper);
    _defineProperty(_this, "componentWillMount", function () {
      var currentPage = 0;
      _this.setState({
        pages: (0, _chunk2["default"])((0, _filter2["default"])(_this.props.reportJson.reports, function (r) {
          return r.reportType === _this.props.reportType;
        }), 4),
        currentPage: currentPage
      });
    });
    _defineProperty(_this, "onRightClick", function () {
      _this.setState({
        currentPage: _this.state.currentPage + 1
      });
    });
    _defineProperty(_this, "onLeftClick", function () {
      _this.setState({
        currentPage: _this.state.currentPage - 1
      });
    });
    _defineProperty(_this, "changeCurrentTab", function (item) {
      _this.setState({
        currentItem: item
      });
      if (_this.props.isSummary) {
        localStorage.setItem("".concat(_this.props.name, "_Report"), item.handle);
      } else {
        localStorage.setItem("".concat(_this.props.name, "_Report"), item.handle);
      }
    });
    _defineProperty(_this, "getReportContent", function (item, handle) {
      var ReportAdapterComponent = match[item.adapter];
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: item.handle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].content
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].actionBar
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-info",
        onClick: _this.toggleReportView.bind(null)
      }, _this.state.isReportPaginated && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_pagebreak["default"], null), " Browser View"), !_this.state.isReportPaginated && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_pageBreak["default"], null), " Printer View"))), /*#__PURE__*/_react["default"].createElement(ReportAdapterComponent, _extends({
        entityProps: {
          selectedEntity: _this.props.selectedEntity,
          typeLabel: _this.props.selectedEntityTypeLabel,
          textFieldPath: _this.props.selectedEntityTextFieldPath
        },
        variables: (0, _queryVariablesHelper["default"])(item.adapterProps.requiredVariables, (0, _flat["default"])(_this.props.selectedEntity)),
        isReport: _this.state.isReportPaginated,
        reportHandle: handle,
        displaySettings: _this.props.reportJson.displaySettings
      }, item.adapterProps))));
    });
    _defineProperty(_this, "renderSubNavBody", function () {
      // const ReportHeaderComponent = headerMatch[this.state.currentItem.headerComponent];
      var tabList = [];
      _this.state.currentItem.subNav.forEach(function (sn) {
        tabList.push({
          name: sn.handle,
          title: sn.label,
          content: _this.getReportContent(sn, _this.state.currentItem.handle)
        });
      });
      return /*#__PURE__*/_react["default"].createElement(_cccisdTabs["default"], {
        tabList: tabList,
        orientation: "vertical",
        saveInHash: false,
        verticalTabWidths: _this.props.tabWidths
      });
    });
    _defineProperty(_this, "toggleReportView", function () {
      _this.setState({
        isReportPaginated: !_this.state.isReportPaginated
      });
    });
    _defineProperty(_this, "renderReportBody", function () {
      return _this.getReportContent(_this.state.currentItem, _this.state.currentItem.handle);
    });
    _defineProperty(_this, "renderBody", function () {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: _this.state.currentItem.handle,
        className: _style["default"].body
      }, 'subNav' in _this.state.currentItem && _this.renderSubNavBody(), !('subNav' in _this.state.currentItem) && _this.renderReportBody());
    });
    var currentItem = (0, _filter2["default"])(props.reportJson.reports, function (r) {
      return r.reportType === props.reportType;
    })[0];
    if (localStorage["".concat(props.name, "_Report")]) {
      currentItem = (0, _find2["default"])((0, _filter2["default"])(props.reportJson.reports, function (r) {
        return r.reportType === props.reportType;
      }), function (r) {
        return r.handle === localStorage.getItem("".concat(props.name, "_Report"));
      });
    }
    _this.state = {
      pages: [],
      currentPage: 0,
      currentItem: currentItem,
      isReportPaginated: false
    };
    return _this;
  }
  _inherits(ReportWrapper, _Component);
  return _createClass(ReportWrapper, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].reportNavContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].reportNav
      }, this.state.currentPage !== 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames3["default"])(_defineProperty({}, _style["default"].arrowLeft, true)),
        onClick: this.onLeftClick
      }, /*#__PURE__*/_react["default"].createElement(_arrowLeft["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
        className: " ".concat(this.state.pages[this.state.currentPage].length > 2 && _tabs["default"].tabColumn)
      }, this.state.pages[this.state.currentPage].map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("a", {
          key: item.handle,
          className: "".concat(_tabs["default"].tab, " ").concat(item.handle === _this2.state.currentItem.handle && _tabs["default"].active),
          onClick: _this2.changeCurrentTab.bind(null, item)
          // style={{ backgroundColor: 'red' }}
        }, 'icon' in item && /*#__PURE__*/_react["default"].createElement("span", {
          className: 'icon ' + _style["default"].icon
        }, /*#__PURE__*/_react["default"].createElement("svg", {
          width: "15",
          height: "15",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: item.icon.viewBox
        }, /*#__PURE__*/_react["default"].createElement("g", null, item.icon.paths.map(function (p) {
          return /*#__PURE__*/_react["default"].createElement("path", {
            key: p,
            d: p
          });
        })))), item.label);
      })), this.state.currentPage !== this.state.pages.length - 1 && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames3["default"])(_defineProperty({}, _style["default"].arrowRight, true)),
        onClick: this.onRightClick
      }, /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], null))), this.renderBody());
    }
  }]);
}(_react.Component);
ReportWrapper.propTypes = {
  // unique name of this report component
  name: _propTypes["default"].string,
  // the json for all reports
  reportJson: _propTypes["default"].object,
  entityType: _propTypes["default"].string,
  // what entity are we showing reports for
  selectedEntity: _propTypes["default"].object,
  // what nexus class is the entity? (pawn or group)
  selectedEntityNexusClass: _propTypes["default"].string,
  // what is the type of thing in the system ex. "client"
  selectedEntityType: _propTypes["default"].string,
  // what is the label of the entity (user facing) ex. "Client"
  selectedEntityTypeLabel: _propTypes["default"].string,
  // what path to get the label for the entity
  selectedEntityTextFieldPath: _propTypes["default"].string,
  // json with standard structure for fields
  // headerFieldsJson: PropTypes.object,

  // what report type are we showing ex. "summary"
  reportType: _propTypes["default"].string,
  // not used yet
  isSummary: _propTypes["default"].bool,
  // redux props
  getData: _propTypes["default"].func,
  formattedData: _propTypes["default"].array,
  loading: _propTypes["default"].bool,
  tabWidths: _propTypes["default"].object
};
ReportWrapper.defaultProps = {
  entityType: 'pawn',
  tabWidths: {
    left: 3,
    right: 9
  }
};
var _default = exports["default"] = ReportWrapper;